import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, ViewController  } from 'ionic-angular';
import { MovimientocarteraServiceProvider} from '../../providers/movimientocartera-service/movimientocartera-service';
import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import {DomSanitizer} from '@angular/platform-browser';
/**
 * Generated class for the EnviocorreoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-enviocorreo',
  templateUrl: 'enviocorreo.html',
})
export class EnviocorreoPage {

  datos={};
  idtusuario=0;
  constructor(public platform: Platform, public navCtrl: NavController, public navParams: NavParams, 
    public viewCtrl: ViewController, public movcarService : MovimientocarteraServiceProvider,
    public sanitizer: DomSanitizer, public auth:AuthServiceProvider) {

    this.idtusuario = auth.usuario['idtusuario'];

  	this.datos = {
        id: this.navParams.get('id'),
        entidad: this.navParams.get('entidad'),
        email: this.navParams.get('correo'),
        asunto: 'Comprobante nº '+this.navParams.get('id')+' de PROPIEDAD HORIZONTAL EDIFICIO POSEIDON',
        mensaje: 'Estimado/a '+this.navParams.get('entidad')+
        ', \nEl siguiente correo es la confirmación del pago del departamento Nº'+this.navParams.get('ndepartamento')+'. \n\nAdjunto encontrara una copia en PDF. \n\nSaludos,\nPROPIEDAD HORIZONTAL EDIFICIO POSEIDON'
      };

  }

  urlpdf() {
    var ddd = this.sanitizer.bypassSecurityTrustResourceUrl(this.movcarService.serverServicios + '/comprobante N'+this.navParams.get('id')+'.pdf');
    return ddd;
  }

  ionViewDidLoad() {
  }

  enviar() {
    this.movcarService.enviarcomprobante(this.datos).then((result) => {

      },(err) => {
        console.log(err);
     });
    this.dismiss();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/enviocorreo/enviocorreo.ts